// extracted by mini-css-extract-plugin
export var authorCard = "T_cH";
export var authorCardContent = "T_cK";
export var authorCardImage = "T_cJ";
export var bottom = "T_cQ";
export var description = "T_cP";
export var name = "T_cM";
export var role = "T_cN";
export var top = "T_cL";